import React from 'react';
import BaseTextField from '@material-ui/core/TextField';
import { Grid, InputLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';

import { TEXT_FIELD_COLOR, TEXT_FIELD_VARIANT } from '../../enum/formProps';

import './TextField.scss';

interface TextFieldProps {
  label: string;
  name: string;
  type: string;
  color?: TEXT_FIELD_COLOR;
  variant?: TEXT_FIELD_VARIANT;
  disabled?: boolean;
  className?: string;
}

const TextField: React.FC<TextFieldProps> = ({ label, ...props }) => {
  const { t } = useTranslation();
  const [field, meta] = useField(props);
  const isError = !!(meta.error && meta.touched);

  return (
    <Grid container spacing={0} className="TextField-Container">
      <Grid item xs={4} md={3} lg={2} xl={1}>
        <InputLabel className="TextField-InputLabel" error={isError} disabled={props.disabled}>
          {t(label)}
        </InputLabel>
      </Grid>
      <Grid item xs={8} md={9} lg={10} xl={11}>
        <BaseTextField
          className={props.className}
          error={isError}
          disabled={props.disabled}
          fullWidth
          helperText={isError ? t(meta.error ?? '') : ''}
          color={props.color}
          id={props.name}
          {...field}
          {...props}
        />
      </Grid>
    </Grid>
  );
};

export default TextField;
